import {
  Avatar,
  Breadcrumb,
  Button,
  Card,
  Col,
  Collapse,
  Divider,
  Empty,
  Form,
  Icon,
  message,
  Modal,
  Popconfirm,
  Row,
  Table,
  Tabs,
} from 'antd';
import gql from 'graphql-tag';
import moment from 'moment';
import React, { Component } from 'react';
import { Mutation, MutationFn, Query } from 'react-apollo';
import { Link } from 'react-router-dom';
import { PaymentMethodName } from 'smartpi-core';

import { Panel } from '../../components/Panel';
import { FormatDate } from '../../components/table/Date';
import { client } from '../../services/api';
import { DateRange } from '../../types/base';
import {
  MarketActivityType,
  MarketingActivity,
  MarketingActivityRuleKey,
  RuleUsersLimitSchema,
} from '../../types/marketingActivity';
import { Enrollment, LessonProgresses, LessonStatus, MiniGameNames } from '../enrollment/Enrollment';
import { MarketingActivityData, marketingActivityQuery } from '../group/GroupDetail';
import { AccountTransactionRecords } from './AccountTransactionRecords';
import { CheckInRecords } from './CheckInRecords';
import { ClockInRecords } from './ClockInRecords';
import { ContactRecords } from './ContactRecords';
import { EditableUserBasicInfo, EditUserBasicInfo } from './EditUserBasicInfo';
import { SlmRecords } from './SlmRecords';
import { TransferOwnerOfCourse } from './TransferOwnerOfCourse';
import { TransferSkuToAnother } from './TransferSku';
import { TransferSkuToAnotherWithCourse } from './TransferSkuWidthCourse';
import { UserDevices, UserDeviceStatus } from './type';
import {
  AbilityNames,
  ALL_USERS_QUERY,
  AllUsers,
  ChildPersona,
  ChildPersonaType,
  GradeNames,
  KNOWLEDGE_POINT_LEVEL,
  Order,
  OrderStatus,
  OrderStatusName,
  PaymentInvoices,
  PaymentInvoiceStatusName,
  User,
  UserMeta,
  UserMetaType,
  UserThirdPartyInfo,
} from './Users';

const ButtonGroup = Button.Group;
const EditUserBasicInfoForm: any = Form.create()(EditUserBasicInfo);
interface Props {
  match: any;
}

interface State {
  clockInDateRange: DateRange;
  marketingActivityFilterOptions: MarketingActivity[];
  selectedMarketingActivityFilter: number;
  isOfferTransferEnrollmentToAnotherSkuPopupConfirmVisible: boolean;
  enrollmentId?: number;
  skuId?: number;
  isOfferUnbindMobileConfirmVisible: boolean;
  isUserDeviceVisible: boolean;
}
export const ADMISSION_QUIZ: MiniGameNames = MiniGameNames.ADMISSION_QUIZ;
export const skusListQuery = gql`
  query skusList($startRange: DateRange, $name: String, $ids: [ID], $skuGroupIds: [ID]) {
    skus(startRange: $startRange, name: $name, ids: $ids, skuGroupIds: $skuGroupIds) {
      id
      name
      course {
        id
        name
        serialId
      }
      groups {
        id
        name
      }
      enrollmentGroups {
        id
        name
        teacherId
        enrollments {
          id
          groupId
        }
      }
      start
      end
      quizEndAt
    }
  }
`;
// 查找用户设备
export const userDeviceQuery = gql`
  query getUserDeviceQuery($userId: Int) {
    userDevices(userId: $userId) {
      id
      userAgent
      status
      userId
      updatedAt
    }
  }
`;

// 解绑设备
export const updateUserDeviceMutation = gql`
  mutation updateUserDevice($ids: [ID], $userId: Int) {
    updateUserDevice(ids: $ids, userId: $userId) {
      id
    }
  }
`;

const fulfillOrderMutation = gql`
  mutation fulfillOrder($orderId: ID!) {
    fulfillOrder(id: $orderId) {
      id
      status
    }
  }
`;

const refundOrderMutation = gql`
  mutation refundOrder($orderId: ID!) {
    refundOrder(id: $orderId) {
      id
      status
      paymentInvoices {
        id
        status
        amount
        paymentMethod
        createdAt
        updatedAt
      }
    }
  }
`;
export const transferEnrollmentToAnotherSkuMutation = gql`
  mutation transferEnrollmentToAnotherSku($id: ID, $skuId: ID, $sameTeacher: Boolean, $groupId: ID) {
    transferEnrollmentToAnotherSku(id: $id, skuId: $skuId, sameTeacher: $sameTeacher, groupId: $groupId) {
      id
    }
  }
`;
const unbindMobileMutation = gql`
  mutation unbindMobile($userId: ID!) {
    unbindMobile(userId: $userId) {
      id
    }
  }
`;
export class UserDetail extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      clockInDateRange: { from: new Date(), to: new Date() },
      marketingActivityFilterOptions: [],
      selectedMarketingActivityFilter: 0,
      isOfferTransferEnrollmentToAnotherSkuPopupConfirmVisible: false,
      isOfferUnbindMobileConfirmVisible: false,
      isUserDeviceVisible: false,
    };
    this.onOfferTransferEnrollmentToAnotherSkuClick = this.onOfferTransferEnrollmentToAnotherSkuClick.bind(this);
    this.onReviewTransferEnrollmentToAnotherSkuClick = this.onReviewTransferEnrollmentToAnotherSkuClick.bind(this);
    this.onReviewUnbindMobileClick = this.onReviewUnbindMobileClick.bind(this);
    this.onOfferUnbindMobileClick = this.onOfferUnbindMobileClick.bind(this);
    this.onUserDeviceModalHandleCancel = this.onUserDeviceModalHandleCancel.bind(this);
  }
  async componentDidMount() {
    const response = await client.query<MarketingActivityData>({
      query: marketingActivityQuery,
    });
    this.setState({
      marketingActivityFilterOptions: response.data.marketingActivities,
    });
  }

  getUserMetaByKey(metas: UserMeta[], key: UserMetaType): UserMeta[] {
    return metas.filter(meta => meta.key === key);
  }
  onUserDeviceModalHandleCancel() {
    this.setState({
      isUserDeviceVisible: false,
    });
  }

  async onModalClick() {
    this.setState({
      isUserDeviceVisible: true,
    });
  }

  userDevices() {
    return (
      <Query<UserDevices> query={userDeviceQuery} variables={{ userId: this.props.match.params.id }}>
        {({ loading, error, data }) => {
          if (error) return <div>{error.message}</div>;
          if (loading) return <div>loading...</div>;
          if (!data) {
            // @ts-ignore
            return <Empty />;
          }
          const userDevices = (data && data.userDevices) || [null];
          const bindingUserDevices = userDevices.filter(userDevice => {
            return userDevice.status === UserDeviceStatus.BINDING;
          });
          const unbindUserDevices = userDevices.filter(userDevice => {
            return userDevice.status === UserDeviceStatus.UNBIND;
          });
          return (
            <>
              {bindingUserDevices.length === 0 ? (
                <div>目前暂无绑定设备信息</div>
              ) : (
                <div>
                  {bindingUserDevices.map((bindingUserDevice, index) => {
                    return (
                      <div key={bindingUserDevice.id} style={{ marginBottom: '10px' }}>
                        <span>{`${index + 1}.设备信息：${bindingUserDevice.userAgent}`}</span>
                        <span style={{ marginLeft: '10px' }}>
                          {`绑定日期：${moment(bindingUserDevice.updatedAt).format('YYYY/MM/DD')}`}
                        </span>
                        <Mutation
                          mutation={updateUserDeviceMutation}
                          variables={{
                            userId: this.props.match.params.id,
                            ids: [bindingUserDevice.id],
                          }}
                          refetchQueries={[
                            {
                              query: userDeviceQuery,
                              variables: { userId: this.props.match.params.id },
                            },
                          ]}
                        >
                          {updateUserDeviceMutation => {
                            return (
                              <Button
                                style={{ marginLeft: '10px' }}
                                type="primary"
                                onClick={async () => {
                                  await this.confirmUnbindModal(updateUserDeviceMutation);
                                }}
                              >
                                解绑该设备
                              </Button>
                            );
                          }}
                        </Mutation>
                      </div>
                    );
                  })}
                </div>
              )}
              <Modal
                title="解绑记录"
                visible={this.state.isUserDeviceVisible}
                onCancel={this.onUserDeviceModalHandleCancel}
                footer={[null, null]}
              >
                {unbindUserDevices.map((unbindUserDevice, index) => {
                  return (
                    <div key={unbindUserDevice.id}>
                      <span>{`${index + 1}.设备信息：${unbindUserDevice.userAgent}`} </span>
                      <span>{`  解绑时间：${moment(unbindUserDevice.updatedAt).format('YYYY/MM/DD')}`} </span>
                    </div>
                  );
                })}
              </Modal>
            </>
          );
        }}
      </Query>
    );
  }

  async confirmUnbindModal(
    updateUserDeviceMutation: MutationFn<{
      userId: number;
      ids: number;
    }>,
  ) {
    Modal.confirm({
      title: '确定',
      content: '确定解绑该设备吗？',
      okText: '确认',
      cancelText: '取消',
      onOk: async () => {
        try {
          await updateUserDeviceMutation();
          message.success('解绑成功！');
        } catch {
          message.error('解绑失败！');
        }
      },
    });
  }

  getChildPersonaByType(personas: ChildPersona[], type: ChildPersonaType) {
    return personas.filter(persona => persona.type === type);
  }
  getCombainedInviterUserNames(inviterRelations: { inviter: User }[]) {
    return inviterRelations.map((inviterRelation, index) => {
      if (index === inviterRelations.length - 1) {
        return `${inviterRelation.inviter && inviterRelation.inviter.name}`;
      }
      return `${inviterRelation.inviter && inviterRelation.inviter.name}，`;
    });
  }
  getCombainedInviteeUserNames(inviteeRelations: { invitee: User }[]) {
    return inviteeRelations.map((inviteeRelation, index) => {
      if (index === inviteeRelations.length - 1) {
        return `${inviteeRelation.invitee && inviteeRelation.invitee.name}`;
      }
      return `${inviteeRelation.invitee && inviteeRelation.invitee.name}，`;
    });
  }
  getLessonNameByStatus(progresses: LessonProgresses[], lessonStatusList: LessonStatus[]) {
    if (!progresses.length) {
      return;
    }
    const lessonNames = progresses
      .filter(progresses => {
        return lessonStatusList.indexOf(progresses.status) > -1;
      })
      .map(lesson => lesson.displayId || lesson.serialId)
      .join(', ');
    return lessonNames;
  }
  getLessonProgress(progresses: LessonProgresses[]) {
    if (!progresses.length) {
      return 0;
    }
    const playedLessonStatus: LessonStatus[] = [LessonStatus.PLAYED];
    const notPlayedLessonStatus: LessonStatus[] = [LessonStatus.LOCKED, LessonStatus.UNLOCKED, LessonStatus.HIGHLIGHT];

    const playedLessons = progresses.filter(lesson => {
      return playedLessonStatus.indexOf(lesson.status) > -1;
    });
    const notPlayedLessons = progresses.filter(lesson => {
      return notPlayedLessonStatus.indexOf(lesson.status) > -1;
    });
    return (playedLessons.length / (playedLessons.length + notPlayedLessons.length)) * 100;
  }

  correctRate(resultRecord: boolean[]) {
    const trueList = resultRecord.filter(item => item);

    return `${trueList.length} / ${resultRecord.length}`;
  }
  onReviewTransferEnrollmentToAnotherSkuClick() {
    this.setState({
      isOfferTransferEnrollmentToAnotherSkuPopupConfirmVisible: true,
    });
  }
  onOfferTransferEnrollmentToAnotherSkuClick() {
    this.setState({ isOfferTransferEnrollmentToAnotherSkuPopupConfirmVisible: false });
  }

  levelTestResultPart(enrollment: Enrollment) {
    // 测评部分
    const userId = this.props.match.params.id;
    const quizEndAt = enrollment.sku.quizEndAt;
    const effectiveQuiz = enrollment.miniGameResults.filter(item =>
      moment(item.createdAt).isSameOrBefore(moment(quizEndAt)),
    );
    if (!quizEndAt) {
      return null;
    }

    return (
      <div>
        <Row gutter={24}>
          {effectiveQuiz.length > 0 && (
            <div>
              <Col span={5} style={{ textAlign: 'right' }}>
                分班测评:
              </Col>
              <Col span={7}>第{effectiveQuiz.length}次测评</Col>
            </div>
          )}
        </Row>
        <Divider />
        <Collapse bordered={false} defaultActiveKey={['1']}>
          {enrollment.miniGameResults.map((miniGameResult, index) => {
            return (
              <Collapse.Panel header={`第${index + 1}次测评`} key={`${miniGameResult.id}`}>
                <Row gutter={24}>
                  <Col span={5} style={{ textAlign: 'right' }}>
                    测评时间
                  </Col>
                  <Col span={7}>
                    <FormatDate mode="datetime" date={miniGameResult.createdAt} />
                  </Col>

                  <Col span={5} style={{ textAlign: 'right' }}>
                    测评时长
                  </Col>
                  <Col span={7}>{Math.ceil(miniGameResult.data.time / 1000 / 60)}分钟</Col>
                </Row>
                <Row gutter={24}>
                  <Col span={5} style={{ textAlign: 'right' }}>
                    知识点水平
                  </Col>
                  <Col span={7}>
                    {miniGameResult.data.knowledgeLevel}-{KNOWLEDGE_POINT_LEVEL[miniGameResult.data.knowledgeLevel]}
                  </Col>

                  <Col span={5} style={{ textAlign: 'right' }}>
                    算数水平
                  </Col>
                  <Col span={7}>9.9-{miniGameResult.data.level}</Col>
                </Row>
                <Row gutter={24}>
                  <Col span={5} style={{ textAlign: 'right' }}>
                    正确率
                  </Col>
                  <Col span={7}> {this.correctRate(miniGameResult.data.resultRecord)}</Col>
                </Row>
              </Collapse.Panel>
            );
          })}
        </Collapse>
        <Row>
          <Link to={`/user/${userId}/enrollment/${enrollment.id}/lesson/R1`}>课后测评结果链接</Link>
          <Divider />
        </Row>
      </div>
    );
  }

  onReviewUnbindMobileClick() {
    this.setState({ isOfferUnbindMobileConfirmVisible: true });
  }

  onOfferUnbindMobileClick() {
    this.setState({ isOfferUnbindMobileConfirmVisible: false });
  }

  unbindMobileConfirmModal(thirdPartyInfos: UserThirdPartyInfo[]) {
    if (!thirdPartyInfos.length && this.state.isOfferUnbindMobileConfirmVisible) {
      this.setState({ isOfferUnbindMobileConfirmVisible: false });
      message.warning('请先绑定微信！');
      return;
    }
    const userId = this.props.match.params.id;
    const { marketingActivityFilterOptions, clockInDateRange } = this.state;
    if (!marketingActivityFilterOptions.length) {
      return;
    }
    return (
      <div>
        <Mutation
          mutation={unbindMobileMutation}
          variables={{ userId }}
          refetchQueries={[
            {
              query: ALL_USERS_QUERY,
              variables: { ids: [userId], dateRange: clockInDateRange, miniGameName: ADMISSION_QUIZ },
            },
          ]}
        >
          {(unbindMobile, { loading }) => {
            return (
              <Modal
                title="解绑手机号"
                visible={this.state.isOfferUnbindMobileConfirmVisible}
                okText="确认"
                cancelText="取消"
                onOk={async () => {
                  try {
                    if (loading) {
                      return;
                    }
                    await unbindMobile();
                    message.success('操作成功');
                    this.setState({ isOfferUnbindMobileConfirmVisible: false });
                  } catch (e) {
                    message.error('失败！');
                  }
                }}
                onCancel={this.onOfferUnbindMobileClick}
              >
                <p>解绑后用户将无法通过手机号登录，确认解绑吗？</p>
              </Modal>
            );
          }}
        </Mutation>
      </div>
    );
  }

  private skuIds: number[] = [];
  filterMarketingActivitiesBySku = (marketingActivities: MarketingActivity[]) => {
    const marketingActivitiesBySkuId = marketingActivities.filter(marketingActivity => {
      const rules = marketingActivity.rules;
      return rules.some(rule => {
        if (rule.ruleKey === MarketingActivityRuleKey.MA_RULE_USERS_LIMIT_CONFIG) {
          const ruleValue = rule.ruleValue as RuleUsersLimitSchema;
          return this.skuIds.some(skuId => Number(skuId) === ruleValue.ownedSkuId);
        }
        return false;
      });
    });
    const marketingActivitiesBySkuIdList = marketingActivitiesBySkuId.filter(
      marketingActivity =>
        marketingActivity.type === MarketActivityType.CLOCK_IN || marketingActivity.type === MarketActivityType.POINT,
    );
    return marketingActivitiesBySkuIdList;
  };

  render() {
    const userId = this.props.match.params.id;
    const { marketingActivityFilterOptions } = this.state;
    if (!this.state.marketingActivityFilterOptions.length) {
      return null;
    }

    const transferNeedData: {
      marketingActivityFilterOptions: MarketingActivity[];
      selectedMarketingActivityFilter: number;
      clockInDateRange: DateRange;
    } = this.state;

    return (
      <>
        <Breadcrumb style={{ marginBottom: 10, fontSize: 13 }}>
          <Breadcrumb.Item>
            <Link to={`/Home`}>首页</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>用户详情</Breadcrumb.Item>
        </Breadcrumb>
        <AllUsers query={ALL_USERS_QUERY} variables={{ ids: [userId], miniGameName: ADMISSION_QUIZ }}>
          {({ loading, error, data }) => {
            if (error) return <div>{error.message}</div>;
            if (loading) return <div>loading...</div>;
            if (!data) {
              // @ts-ignore
              return <Empty />;
            }
            const [user] = data.users || {};

            if (!user) {
              return <div>用户不存在</div>;
            }

            const [userMetaRealName] = this.getUserMetaByKey(user.userMeta, UserMetaType.REAL_NAME);
            const [userMetaFamilyRole] = this.getUserMetaByKey(user.userMeta, UserMetaType.FAMILY_ROLE);
            const [userMetaAge] = this.getUserMetaByKey(user.userMeta, UserMetaType.AGE);
            const [userMetaRemark] = this.getUserMetaByKey(user.userMeta, UserMetaType.REMARK);
            const [userMetaAddress] = this.getUserMetaByKey(user.userMeta, UserMetaType.ADDRESS);
            const [userEmergencyContact] = this.getUserMetaByKey(user.userMeta, UserMetaType.EMERGENCY_CONTACT);
            const defaultUserBasicInfo: EditableUserBasicInfo = {
              realName: userMetaRealName && userMetaRealName.value,
              familyRole: userMetaFamilyRole && userMetaFamilyRole.value,
              age: userMetaAge && userMetaAge.value,
              remark: userMetaRemark && userMetaRemark.value,
              address: userMetaAddress && userMetaAddress.value,
              emergencyContact: userEmergencyContact && userEmergencyContact.value,
            };
            const [primaryContact = '', secondaryContact = '', generalContact = ''] = userEmergencyContact
              ? userEmergencyContact.value.split('/')
              : '';
            const enrollments = user.enrollments;
            this.skuIds = enrollments.map(enrollment => enrollment.sku.id);

            let address = '';
            if (userMetaAddress) {
              const [province = '', city = '', detail = '', consignee = '', mobile = ''] = userMetaAddress.value.split(
                '/',
              );
              address = `${province}${city}${detail}${consignee}${mobile}`;
            }

            return (
              <Card
                title="用户详情"
                extra={
                  <div>
                    <Button style={{ marginLeft: 8 }} type="primary" icon="download">
                      导出
                    </Button>
                    <Button type="danger" style={{ marginLeft: 8 }} icon="close">
                      关闭
                    </Button>
                  </div>
                }
              >
                <Card title="基本信息" type="inner">
                  <Row gutter={24}>
                    <Col span={5} style={{ textAlign: 'right' }}>
                      头像
                    </Col>
                    <Col span={14} style={{ textAlign: 'left' }}>
                      <div>
                        <Avatar shape="square" size={64} src={user.avatarUrl} />
                      </div>
                    </Col>
                    <Col span={5} style={{ textAlign: 'left' }}>
                      <EditUserBasicInfoForm
                        userId={userId}
                        miniGameName={ADMISSION_QUIZ}
                        defaultUserBasicInfo={defaultUserBasicInfo}
                      />
                    </Col>
                  </Row>
                  <Row gutter={24}>
                    <Col span={5} style={{ textAlign: 'right' }}>
                      姓名
                    </Col>
                    <Col span={7}>{userMetaRealName && userMetaRealName.value}</Col>

                    <Col span={5} style={{ textAlign: 'right' }}>
                      手机号码
                    </Col>
                    <Col span={7}>
                      {user.mobile && (
                        <div>
                          <span style={{ marginRight: 5 }}>{user.mobile}</span>
                          <Button type="primary" size="small" onClick={this.onReviewUnbindMobileClick}>
                            解绑
                          </Button>
                          {this.unbindMobileConfirmModal(user.thirdPartyInfos)}
                        </div>
                      )}
                    </Col>
                  </Row>
                  <Row gutter={24}>
                    <Col span={5} style={{ textAlign: 'right' }}>
                      性别
                    </Col>
                    <Col span={7}>
                      {user.gender === 1 && '男'}
                      {user.gender === 2 && '女'}
                    </Col>

                    <Col span={5} style={{ textAlign: 'right' }}>
                      家长角色
                    </Col>

                    <Col span={7}>{userMetaFamilyRole && userMetaFamilyRole.value}</Col>
                  </Row>
                  <Row gutter={24}>
                    <Col span={5} style={{ textAlign: 'right' }}>
                      微信昵称
                    </Col>
                    <Col span={7}>{user.name}</Col>

                    <Col span={5} style={{ textAlign: 'right' }}>
                      年龄
                    </Col>

                    <Col span={7}>{userMetaAge && userMetaAge.value}</Col>
                  </Row>
                  <Row gutter={24}>
                    <Col span={5} style={{ textAlign: 'right' }}>
                      用户渠道来源
                    </Col>
                    <Col span={7} />

                    <Col span={5} style={{ textAlign: 'right' }}>
                      地址
                    </Col>

                    <Col span={7}>{user.region}</Col>
                  </Row>
                  {/* <Row gutter={24}>
                    <Col span={5} style={{ textAlign: 'right' }}>
                      下游用户
                    </Col>
                    <Col span={7}>{this.getCombainedInviterUserNames(user.inviterRelations)}</Col>

                    <Col span={5} style={{ textAlign: 'right' }}>
                      上游用户
                    </Col>

                    <Col span={7}>{this.getCombainedInviteeUserNames(user.inviteeRelations)}</Col>
                  </Row> */}
                  <Row gutter={24}>
                    <Col span={5} style={{ textAlign: 'right' }}>
                      备注
                    </Col>
                    <Col span={7}>{userMetaRemark && userMetaRemark.value}</Col>
                    <Col span={5} style={{ textAlign: 'right' }}>
                      用户权限
                    </Col>
                    <Col span={7}>
                      <TransferOwnerOfCourse userId={Number(userId)} />
                    </Col>
                  </Row>
                  <Row gutter={24}>
                    <Col span={5} style={{ textAlign: 'right' }}>
                      收货地址
                    </Col>
                    <Col span={17}>{address}</Col>
                  </Row>
                  <Row gutter={24}>
                    <Col span={5} style={{ textAlign: 'right' }}>
                      紧急联系人1
                    </Col>
                    <Col span={7}>{primaryContact}</Col>
                    <Col span={5} style={{ textAlign: 'right' }}>
                      推荐人
                    </Col>
                    <Col span={7}>
                      {user.inviter && <Link to={`/user/${user.inviter.id}`}>{user.inviter.mobile}</Link>}
                    </Col>
                  </Row>

                  <Row gutter={24}>
                    <Col span={5} style={{ textAlign: 'right' }}>
                      紧急联系人2
                    </Col>
                    <Col span={7}>{secondaryContact}</Col>
                    <Col span={5} style={{ textAlign: 'right' }}>
                      邀请的好友
                    </Col>
                    <Col span={6}>
                      {user.invitees.length > 0 &&
                        user.invitees.map(invitee => (
                          <div key={invitee.id}>
                            <Link to={`/user/${invitee.id}`} key={invitee.id}>
                              {invitee.mobile}
                            </Link>
                          </div>
                        ))}
                    </Col>
                  </Row>

                  <Row gutter={24}>
                    <Col span={5} style={{ textAlign: 'right' }}>
                      紧急联系人3
                    </Col>
                    <Col span={17}>{generalContact}</Col>
                  </Row>
                </Card>

                {user.family && user.family.children.length > 0 && (
                  <Card title="宝贝情况" type="inner" style={{ marginTop: '20px' }}>
                    {user.family.children.map(child => {
                      const [childGrade] = this.getChildPersonaByType(child.personas, ChildPersonaType.GRADE);
                      const childGradeString = childGrade && childGrade.value ? GradeNames[childGrade.value] : null;
                      const [childMathAbility] = this.getChildPersonaByType(
                        child.personas,
                        ChildPersonaType.MATH_ABILITY,
                      );
                      const childMathAbilityString =
                        childMathAbility && childMathAbility.value ? AbilityNames[childMathAbility.value] : null;
                      return (
                        <div key={`${child.id}`}>
                          <Row gutter={24}>
                            <Col span={5} style={{ textAlign: 'right' }}>
                              姓名
                            </Col>
                            <Col span={7}>{child.name}</Col>

                            <Col span={5} style={{ textAlign: 'right' }}>
                              性别
                            </Col>
                            <Col span={7}>
                              {child.gender === 1 && '男'}
                              {child.gender === 2 && '女'}
                            </Col>
                          </Row>
                          <Row gutter={24}>
                            <Col span={5} style={{ textAlign: 'right' }}>
                              出生年月
                            </Col>
                            <Col span={7}>{child.birthday && moment(child.birthday).format('LL')}</Col>

                            <Col span={5} style={{ textAlign: 'right' }}>
                              年级
                            </Col>
                            <Col span={7}>{childGradeString}</Col>
                          </Row>
                          <Row gutter={24}>
                            <Col span={5} style={{ textAlign: 'right' }}>
                              数学能力
                            </Col>
                            <Col span={7}>{childMathAbilityString}</Col>

                            {/* <Col span={5} style={{ textAlign: 'right' }}>
                            年级
                          </Col>
                          <Col span={7}>{childGradeString}</Col> */}
                          </Row>
                        </div>
                      );
                    })}
                  </Card>
                )}
                <Card title="课程信息" type="inner" style={{ marginTop: '20px' }}>
                  <Collapse bordered={false} defaultActiveKey={['1']}>
                    {user.enrollments.map(enrollment => {
                      const enrollmentProgressPercent = this.getLessonProgress(enrollment.lessonProgresses);

                      // const quizEndAt = enrollment.sku.quizEndAt;
                      // const effectiveQuiz = enrollment.miniGameResults.filter(item =>
                      //   moment(item.createdAt).isSameOrBefore(moment(quizEndAt)),
                      // );
                      return (
                        <Collapse.Panel
                          header={`${enrollment.sku.course.name} - ${enrollment.sku.name}`}
                          key={`${enrollment.id}`}
                        >
                          <Row gutter={24}>
                            <Col span={5} style={{ textAlign: 'right' }}>
                              课程期数
                            </Col>
                            <Col span={7}>-</Col>

                            <Col span={5} style={{ textAlign: 'right' }}>
                              购课时间
                            </Col>
                            <Col span={7}>-</Col>
                          </Row>
                          <Row gutter={24}>
                            <Col span={5} style={{ textAlign: 'right' }}>
                              购课活动
                            </Col>
                            <Col span={7}>-</Col>

                            <Col span={5} style={{ textAlign: 'right' }}>
                              定金金额
                            </Col>
                            <Col span={7}>-</Col>
                          </Row>
                          <Row gutter={24}>
                            <Col span={5} style={{ textAlign: 'right' }}>
                              上课时间
                            </Col>
                            <Col span={7}>{`${moment(enrollment.sku.start).format('L')} - ${moment(
                              enrollment.sku.end,
                            ).format('L')}`}</Col>

                            <Col span={5} style={{ textAlign: 'right' }}>
                              购课渠道来源
                            </Col>
                            <Col span={7}>-</Col>
                          </Row>
                          <Row gutter={24}>
                            <Col span={5} style={{ textAlign: 'right' }}>
                              社群
                            </Col>
                            <Col span={7}>{enrollment.group && enrollment.group.name}</Col>
                            <Col span={5} style={{ textAlign: 'right' }}>
                              老师
                            </Col>
                            <Col span={7}>
                              {enrollment.group && enrollment.group.teacher && enrollment.group.teacher.name}
                            </Col>
                          </Row>
                          <Divider />
                          <ButtonGroup>
                            <Button disabled>学习报告</Button>
                            <Button>
                              <Link to={`/user/${user.id}/enrollment/${enrollment.id}/lesson`}>查看详情</Link>
                            </Button>
                          </ButtonGroup>
                          <Divider />
                          <Row gutter={24}>
                            <Col span={5} style={{ textAlign: 'right' }}>
                              已开课时
                            </Col>
                            <Col span={7}>
                              {this.getLessonNameByStatus(enrollment.lessonProgresses, [
                                LessonStatus.LOCKED,
                                LessonStatus.UNLOCKED,
                                LessonStatus.HIGHLIGHT,
                                LessonStatus.PLAYED,
                              ])}
                            </Col>
                            <Col span={5} style={{ textAlign: 'right' }}>
                              学习进度
                            </Col>
                            <Col span={7}>
                              {enrollmentProgressPercent && `${enrollmentProgressPercent.toFixed(2)}%`}
                            </Col>
                          </Row>
                          <Row gutter={24}>
                            <Col span={5} style={{ textAlign: 'right' }}>
                              已完成课时
                            </Col>
                            <Col span={7}>
                              {this.getLessonNameByStatus(enrollment.lessonProgresses, [LessonStatus.PLAYED])}
                            </Col>

                            <Col span={5} style={{ textAlign: 'right' }}>
                              未完成课时
                            </Col>
                            <Col span={7}>
                              {this.getLessonNameByStatus(enrollment.lessonProgresses, [
                                LessonStatus.LOCKED,
                                LessonStatus.UNLOCKED,
                                LessonStatus.HIGHLIGHT,
                              ])}
                            </Col>
                          </Row>
                          <Divider />
                          {this.levelTestResultPart(enrollment)}
                          <Row gutter={24}>
                            <Col span={24} style={{ textAlign: 'right' }}>
                              <TransferSkuToAnotherWithCourse
                                transferNeedData={transferNeedData}
                                userId={this.props.match.params.id}
                                enrollment={enrollment}
                              />

                              <TransferSkuToAnother
                                transferNeedData={transferNeedData}
                                userId={this.props.match.params.id}
                                enrollment={enrollment}
                              />
                            </Col>
                          </Row>
                        </Collapse.Panel>
                      );
                    })}
                  </Collapse>
                </Card>
                <Card title="设备管理" type="inner" style={{ marginTop: '20px' }}>
                  <div style={{ display: 'flex', marginBottom: '10px' }}>
                    <div>最大绑定设备数：2</div>
                    <Button
                      style={{ marginLeft: '620px' }}
                      onClick={async () => {
                        await this.onModalClick();
                      }}
                    >
                      解绑记录
                    </Button>
                  </div>
                  {this.userDevices()}
                </Card>

                <Card title="订单信息" type="inner" style={{ marginTop: '20px' }}>
                  <Table<Order>
                    columns={[
                      {
                        title: 'ID',
                        key: 'id',
                        dataIndex: 'id',
                      },
                      {
                        title: 'Skus',
                        key: 'skus',
                        render: record => record.skus.map((sku: { name: string }) => sku.name).join('，'),
                      },
                      {
                        title: '状态',
                        key: 'status',
                        dataIndex: 'status',
                        render: text => OrderStatusName[text],
                      },
                      {
                        title: '创建时间',
                        key: 'createdAt',
                        dataIndex: 'createdAt',
                        render: text => moment(text).format('YYYY-MM-DD, HH:mm'),
                      },
                      {
                        title: '支付记录',
                        key: 'paymentInvoices',
                        render: record => (
                          <ul>
                            {record.paymentInvoices.map((invoice: PaymentInvoices) => (
                              <li key={invoice.id}>
                                {invoice.id}:{PaymentMethodName[invoice.paymentMethod]} ¥{invoice.amount} -{' '}
                                {PaymentInvoiceStatusName[invoice.status]} ({moment(invoice.updatedAt).calendar()})
                              </li>
                            ))}
                          </ul>
                        ),
                      },
                      {
                        title: '操作',
                        key: 'operation',
                        dataIndex: 'status',
                        render: (text, record) => {
                          if (!record.skus.length) {
                            return '';
                          }

                          if (text === OrderStatus.PAID) {
                            return (
                              <Mutation mutation={fulfillOrderMutation} variables={{ orderId: record.id }}>
                                {(fulfillOrder, { loading, error }) => {
                                  return (
                                    <>
                                      <Popconfirm
                                        title={
                                          <Card title="你确定履行订单吗？" bordered={false} style={{ width: 300 }}>
                                            <p>用户名称: {user.name} </p>
                                            <p>订单号: {record.id} </p>
                                            <p>SKU: {record.skus.map(sku => sku.name).join('，')}</p>
                                            <p>
                                              支付记录:
                                              <ul>
                                                {record.paymentInvoices.map(invoice => (
                                                  <li key={invoice.id}>
                                                    {invoice.id}: {PaymentMethodName[invoice.paymentMethod]} ¥
                                                    {invoice.amount} {PaymentInvoiceStatusName[invoice.status]} (
                                                    {moment(invoice.updatedAt).calendar()})
                                                  </li>
                                                ))}
                                              </ul>
                                            </p>
                                            <p style={{ color: 'red' }}>
                                              此操作会 1. 标记订单为已履行 2.标记订单使用的优惠券为已使用 3.添加SKU权限
                                            </p>
                                          </Card>
                                        }
                                        icon={<Icon type="question-circle-o" style={{ color: 'red' }} />}
                                        onConfirm={() => fulfillOrder()}
                                        okText="确定"
                                        cancelText="取消"
                                      >
                                        <Button loading={loading}>履行订单</Button>
                                      </Popconfirm>
                                      {error && <p style={{ color: 'red' }}>{error.message}</p>}
                                    </>
                                  );
                                }}
                              </Mutation>
                            );
                          }

                          if (text === OrderStatus.FULLFILLED) {
                            return (
                              <Mutation mutation={refundOrderMutation} variables={{ orderId: record.id }}>
                                {(refundOrder, { loading, error }) => {
                                  return (
                                    <>
                                      <Popconfirm
                                        title={
                                          <Card title="你确定要退款吗？" bordered={false} style={{ width: 300 }}>
                                            <p>用户名称: {user.name} </p>
                                            <p>订单号: {record.id} </p>
                                            <p>
                                              支付记录:
                                              <ul>
                                                {record.paymentInvoices.map(invoice => (
                                                  <li key={invoice.id}>
                                                    {invoice.id}: {PaymentMethodName[invoice.paymentMethod]} ¥
                                                    {invoice.amount} {PaymentInvoiceStatusName[invoice.status]} (
                                                    {moment(invoice.updatedAt).calendar()})
                                                  </li>
                                                ))}
                                              </ul>
                                            </p>
                                            <p style={{ color: 'red' }}>
                                              此操作会 1. 标记订单为提款中 2. 发起微信退款 3. 退款完成后标记为已退款 4.
                                              删除用户报名记录 5. 给用户发送退款通知
                                            </p>
                                          </Card>
                                        }
                                        icon={<Icon type="question-circle-o" style={{ color: 'red' }} />}
                                        onConfirm={() => refundOrder()}
                                        okText="确定"
                                        cancelText="取消"
                                      >
                                        <Button loading={loading}>发起退课</Button>
                                      </Popconfirm>
                                      {error && <p style={{ color: 'red' }}>{error.message}</p>}
                                    </>
                                  );
                                }}
                              </Mutation>
                            );
                          }
                          return '';
                        },
                      },
                    ]}
                    dataSource={user.orders}
                    rowKey={record => `${record.id}`}
                    pagination={false}
                  />
                </Card>

                <Panel style={{ marginTop: 20 }}>
                  <Card title="行为记录" type="inner">
                    <Tabs defaultActiveKey="1">
                      <Tabs.TabPane tab="跟进记录" key="1">
                        <ContactRecords {...this.props} userId={user.id} />
                      </Tabs.TabPane>
                      <Tabs.TabPane tab="打卡记录" key="2">
                        <ClockInRecords
                          {...this.props}
                          userId={user.id}
                          marketingActivityFilterOptions={this.filterMarketingActivitiesBySku(
                            marketingActivityFilterOptions,
                          )}
                        />
                      </Tabs.TabPane>
                      <Tabs.TabPane tab="积分流水" key="3">
                        <AccountTransactionRecords {...this.props} userId={user.id} />
                      </Tabs.TabPane>
                      <Tabs.TabPane tab="签到记录" key="4">
                        <CheckInRecords
                          {...this.props}
                          userId={user.id}
                          marketingActivityFilterOptions={marketingActivityFilterOptions}
                        />
                      </Tabs.TabPane>
                      <Tabs.TabPane tab="分销记录" key="5">
                        <SlmRecords
                          {...this.props}
                          userId={user.id}
                          marketingActivityFilterOptions={marketingActivityFilterOptions}
                        />
                      </Tabs.TabPane>
                    </Tabs>
                  </Card>
                </Panel>
              </Card>
            );
          }}
        </AllUsers>
      </>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/user/UserDetail.tsx